import { useEffect, useRef } from 'react';

import styles from './InfiniteScrollLoadMore.module.scss';

export type InfiniteScrollLoadMoreProps = {
  searchMode: 'detail' | 'overview';
  activeDetailList?: {
    hasMore: boolean;
    loading: boolean;
    loadMore: () => void;
  };
};

const InfiniteScrollLoadMore = (props: InfiniteScrollLoadMoreProps): JSX.Element => {
  const { searchMode, activeDetailList } = props;
  const loadMoreRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (
      searchMode !== 'detail' ||
      !activeDetailList?.hasMore ||
      activeDetailList.loading ||
      typeof IntersectionObserver === 'undefined'
    ) {
      return;
    }

    const element = loadMoreRef.current;

    if (!element) {
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          activeDetailList?.loadMore();
        }
      },
      {
        rootMargin: '240px 0px',
      }
    );

    observer.observe(element);

    return () => {
      observer.disconnect();
    };
  }, [activeDetailList, searchMode]);

  return (
    <div className={styles.main}>
      <div ref={loadMoreRef} className={styles['load-more-trigger']} />
      <div className={styles.dots}>
        <div className={styles.dot} />
        <div className={styles.dot} />
        <div className={styles.dot} />
      </div>
    </div>
  );
};

export default InfiniteScrollLoadMore;
